module.exports = __webpack_public_path__ + "static/img/background_banner.bacb180.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background_banner.jpg
// module id = 3Xvk
// module chunks = 7